import {
  fetchCompanyStatsPhysicalRevenueTrends,
  fetchCompanyStatsPhysicalRevenueGames,
} from '@/pages/intelligence/services/companies';
import { getComputeTypeStreaming } from '@/pages/intelligence/utils/topchartsUtils';

export async function getPhysicalRevenueTrendData(params, tabId) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const trendsRes = await fetchCompanyStatsPhysicalRevenueTrends({
      ...params,
      order_metric: 'date',
    });
    //1 折线图数据有点冗余，可以在这处理一下
    //2 聚合数据单独拿出来
    //3 后端返回的时间也取出来
    const lineData = trendsRes?.data?.trends_time || [];
    const foundMetric = lineData?.find(
      (item: any) => item?.name === 'physicalRevenue',
    );

    let trendCoundMsg = getComputeTypeStreaming(
      foundMetric?.avg_by_line,
      foundMetric?.total_by_line,
      foundMetric?.max_by_line,
    );

    const tableData = foundMetric?.history || [];

    const trendTotal = tableData?.length;
    return {
      cardStats: {
        isLoading: false,
        isError: false,
        isNoData: !trendTotal,
      },
      lineData: foundMetric?.history || [],
      tableData: tableData,
      total: trendTotal,
      startDate: trendsRes?.req?.start_date || '',
      endDate: trendsRes?.req?.end_date || '',
      trendCoundMsg: trendCoundMsg,
    };
  } catch (err) {
    console.error(err);
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      total: 0,
      startDate: '',
      endDate: '',
      trendCoundMsg: {},
    };
  }
  // const updatedFetchParams: any = updateDefaultTimeParams({
  //   fetchParams: params,
  //   startDate,
  //   endDate,
  //   period: params.period,
  //   isTwoMonths: false,
  // });
  // setFetchParams(updatedFetchParams);
}

export async function getPhysicalRevenueGamesData(params, tabId) {
  // 加载数据，例如从 API
  // 使用 applyFilter 筛选数据
  // 渲染卡片
  try {
    const gamesRes = await fetchCompanyStatsPhysicalRevenueGames(params);
    //1 aggregated为可视化柱状和饼， 需要过滤掉allgame
    //2 表格数据排序和分页需要重新调接口，但可视化不需要更新
    //3 请求折线图接口，需要给top5游戏数据，页面改变筛选器才重新请求

    const tableData = gamesRes?.data?.game_share_data_list || [];
    const fixedData = gamesRes?.data?.game_share_data_total || [];
    tableData.unshift(fixedData)
    const gameTotal = gamesRes?.data?.total_count || 0;
    const lineData = gamesRes?.data?.game_share_metric_time_line || [];
    const barOrPieData = gamesRes?.data?.game_share_pie_chart || [];

    return {
      cardStats: {
        isLoading: false,
        isError: false,
        isNoData: !gameTotal,
      },
      lineData: lineData || [],
      tableData: tableData,
      barOrPieData: barOrPieData,
      total: gameTotal,
    };
  } catch (err) {
    return {
      cardStats: {
        isLoading: false,
        isError: true,
        isNoData: true,
      },
      lineData: [],
      tableData: [],
      barOrPieData: [],
      total: 0,
    };
  }
}
